import { useState } from "react";

export function useControls(isOpen = false) {
  const [state, setState] = useState({
    isOpen,
    open: () => setState((prevState) => ({ ...prevState, isOpen: true })),
    close: () => setState((prevState) => ({ ...prevState, isOpen: false }))
  });
  return state;
}

export class Controls {
  constructor({ onUpdate, isOpen = false }) {
    this.onUpdate = onUpdate;
    this.isOpen = isOpen;
  }
  open = () => {
    this.isOpen = true;
    this.handleUpdate();
  };
  close = () => {
    this.isOpen = false;
    this.handleUpdate();
  };

  handleUpdate = () => {
    const update = {
      isOpen: this.isOpen,
      open: this.open,
      close: this.close
    };
    this.onUpdate(update);
  };
}
